import React from 'react';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import { Grid, Box, FormGroup, FormControlLabel, Checkbox, Link, Dialog, DialogTitle, Container,
    IconButton 
 } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import {
    checkFieldValid,
  } from "components/User/Validation";
import CloseIcon from '@material-ui/icons/Close';
import PasswordField from "components/common/PasswordField";
import { UISignUpLabels, USER_SIGNUP_PROP } from "components/User/constants";

const SignUp = (
    handleClose, setScreen, classes, submitForm, textfields, 
    checkInviteField, user, setFieldChecked, fieldChecked, 
    isFormValid, setUser, privacyChecked, handlePrivacyPolicyCheck,
    setOpenPrivacy, dialogClose, openPrivacy, checkExistingEmail, emailExistsError) => {
    

    return (
        <DialogContent style={{ overflowX: 'hidden' }} className={classes.signupDialog}>
            <Typography className={classes.signupTitle}>
                Create an Account
            </Typography>
            <Grid container spacing={4}>
                <Grid xs={12} sm={6}>
                    <Typography gutterBottom className={classes.signupContent}>
                    <TextField
                        variant="outlined"
                        disabled={checkInviteField('email')}
                        margin="normal"
                        required
                        fullWidth
                        key={'email'}
                        id={'email'}
                        error={
                        (fieldChecked['email'] && !checkFieldValid('email', user['email']))|| emailExistsError
                        }
                        onClick={() => {
                        setFieldChecked({
                            ...fieldChecked,
                            email: true,
                        });
                        }}
                        label={UISignUpLabels.email}
                        name={'email'}
                        autoComplete={'email'}
                        value={user['email']}
                        onChange={(e) => {
                            setUser({
                                ...user,
                                email: e.target.value,
                            });
                        }}
                        onBlur={()=>{checkExistingEmail(user['email'])}}
                        helperText={emailExistsError && "Email ID already exists in the system"}
                    />
                        <TextField
                        variant="outlined"
                        disabled={checkInviteField('firstname')}
                        margin="normal"
                        required
                        fullWidth
                        key={'firstname'}
                        id={'firstname'}
                        error={
                        fieldChecked['firstname'] && !checkFieldValid('firstname', user['firstname'])
                        }
                        onClick={() => {
                        setFieldChecked({
                            ...fieldChecked,
                            firstname: true,
                        });
                        }}
                        label={UISignUpLabels.firstname}
                        name={'firstname'}
                        autoComplete={'firstname'}
                        value={user['firstname']}
                        onChange={(e) => {
                        setUser({
                            ...user,
                            firstname: e.target.value,
                        });
                        }}
                    />
                        <TextField
                            variant="outlined"
                            disabled={checkInviteField('lastname')}
                            margin="normal"
                            required
                            fullWidth
                            key={'lastname'}
                            id={'lastname'}
                            error={
                            fieldChecked['lastname'] && !checkFieldValid('lastname', user['lastname'])
                            }
                            onClick={() => {
                            setFieldChecked({
                                ...fieldChecked,
                                lastname: true,
                            });
                            }}
                            label={UISignUpLabels.lastname}
                            name={'lastname'}
                            autoComplete={'lastname'}
                            value={user['lastname']}
                            onChange={(e) => {
                            setUser({
                                ...user,
                                lastname: e.target.value,
                            });
                            }}
                        />
                        <TextField
                            variant="outlined"
                            disabled={checkInviteField('affiliation')}
                            margin="normal"
                            required
                            fullWidth
                            key={'affiliation'}
                            id={'affiliation'}
                            error={
                            fieldChecked['affiliation'] && !checkFieldValid('affiliation', user['affiliation'])
                            }
                            onClick={() => {
                            setFieldChecked({
                                ...fieldChecked,
                                affiliation: true,
                            });
                            }}
                            label={UISignUpLabels.affiliation}
                            name={'affiliation'}
                            autoComplete={'affiliation'}
                            value={user['affiliation']}
                            onChange={(e) => {
                            setUser({
                                ...user,
                                affiliation: e.target.value,
                            });
                            }}
                        />
                    </Typography>
                </Grid>
                <Grid xs={12} sm={6}>
                    <Typography gutterBottom className={classes.signupContent}>
                    <TextField
                            variant="outlined"
                            margin="normal"
                            fullWidth
                            key={'hearaboutus'}
                            id={'hearaboutus'}
                            onClick={() => {
                            setFieldChecked({
                                ...fieldChecked,
                                hearaboutus: true,
                            });
                            }}
                            label={UISignUpLabels.hearaboutus}
                            name={'hearaboutus'}
                            autoComplete={'hearaboutus'}
                            value={user['hearaboutus']}
                            onChange={(e) => {
                            setUser({
                                ...user,
                                hearaboutus: e.target.value,
                            });
                            }}
                        />
                        <PasswordField
                            variant="outlined"
                            disabled={checkInviteField('password')}
                            margin="normal"
                            required
                            fullWidth
                            
                            key={'password'}
                            id={'password'}
                            error={
                            fieldChecked['password'] &&
                            !checkFieldValid(USER_SIGNUP_PROP.PASSWORD, user['password'])
                            }
                            onClick={() => {
                            setFieldChecked({
                                ...fieldChecked,
                                password: true,
                            });
                            }}
                            label={UISignUpLabels['password']}
                            type="password"
                            name={'password'}
                            autoComplete={'password'}
                            value={user['password']}
                            onChange={(e) => {
                            setUser({
                                ...user,
                                password: e.target.value,
                            });
                            }}
                            reEnterPasswordValid={false}
                        />
                        <PasswordField
                            variant="outlined"
                            disabled={checkInviteField('repeat_password')}
                            margin="normal"
                            required
                            fullWidth
                            key={'repeat_password'}
                            id={'repeat_password'}
                            error={
                                fieldChecked['repeat_password'] &&
                                !checkFieldValid(USER_SIGNUP_PROP.REPEAT_PASSWORD, [user['password'], user['repeat_password']])
                            }
                            onClick={() => {
                            setFieldChecked({
                                ...fieldChecked,
                                repeat_password: true,
                            });
                            }}
                            label={UISignUpLabels['repeat_password']}
                            type="password"
                            name={'repeat_password'}
                            autoComplete={'repeat_password'}
                            helperText = {
                                fieldChecked['repeat_password'] &&
                                !checkFieldValid(USER_SIGNUP_PROP.REPEAT_PASSWORD, [user['password'],user['repeat_password']]) && "Passwords do not match"
                            }
                            value={user['repeat_password']}
                            onChange={(e) => {
                            setUser({
                                ...user,
                                repeat_password: e.target.value,
                            });
                            }}
                            reEnterPasswordValid={user['password'] !== user['repeat_password']}
                        />
                        <FormGroup>
                                <FormControlLabel control={
                                <Checkbox 
                                    checked={privacyChecked}
                                    onChange={handlePrivacyPolicyCheck}
                                />} label={(
                                    <Typography component="div" variant="body2">
                                      I agree to the 
                                      <Link className={classes.privacyLink} underline="always" onClick={() => {
                                        setOpenPrivacy(true);
                                      }}>
                                        Privacy Policy
                                      </Link>
                                    </Typography>
                                  )} />
                        </FormGroup>
                        <Grid container spacing={2}>
                            <Grid item xs={6} align="right" >
                                <Box>
                                    <Button 
                                        fullWidth 
                                        disabled={!isFormValid || !privacyChecked}
                                        loading
                                        variant="contained" 
                                        color="primary"
                                        onClick={(e) => { 
                                            submitForm(e)
                                            setScreen({
                                                confirmation: false,
                                                createAccount: false,
                                                thankYou: true,
                                              })
                                        }}>
                                            Submit
                                    </Button>
                                </Box>
                            </Grid>
                            <Grid item xs={6} align="left">
                                <Box>
                                    <Button fullWidth variant="outlined" onClick={() => {
                                        handleClose();
                                        setScreen({
                                            confirmation: true,
                                            createAccount: false,
                                            thankYou: false,
                                        });
                                    }}>Cancel</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Typography>
                </Grid>
            </Grid>
            <Dialog onClose={dialogClose} aria-labelledby="register-privacy-title" open={openPrivacy} maxWidth={"md"}>
                <DialogTitle id="register-privacy-title">
                  <Container className={classes.privacyHeader}>
                    <Typography component="h1" variant="h5" className={classes.privacyDialogTitle}>
                      Privacy Policy
                    </Typography>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={dialogClose}>
                      <CloseIcon />
                    </IconButton>
                  </Container>
                </DialogTitle>
                <DialogContent>
                  <Container className={classes.privacyDialogContent}>
                    <Typography gutterBottom>
                    <strong>Introduction</strong>

<p>This Arizona State University (<strong>ASU</strong>) Privacy Statement provides information required by Arizona law about ASU’s online information gathering and dissemination practices. Individual pages on ASU websites may provide additional information.</p>

<p>In addition to the information in this Privacy Statement, <a href="https://www.asu.edu/tou/" target="_blank" rel="noopener noreferrer">ASU’s Terms of Use</a> and <a href="https://www.asu.edu/aad/manuals/acd/acd125.html"target="_blank" rel="noopener noreferrer">Computer, Internet, and Electronic Communications Information Management Policy</a> set forth requirements that you must follow when using ASU’s websites and technology network.</p>

<p>If you are in the European Union, please also review <a href="https://www.asu.edu/privacy/#european-union-supplement"target="_blank" rel="noopener noreferrer">ASU’s Supplemental Privacy Provisions for Persons in the European Union</a>. These EU Supplemental Privacy Provisions provide additional information regarding ASU’s processing of personal data you submit or disclose to ASU (or to a third party that transfers it to ASU for processing) while you are in the European Union, Switzerland, or any other jurisdiction that has enacted similar privacy laws.</p>

<p>We encourage you to periodically review this Privacy Statement, as well as any information linked from this Privacy Statement, because we may update it from time to time.</p>

<strong>Services ASU provides online, and services provided by non-ASU service providers</strong>

<p>ASU’s websites provide online information and services to all users of ASU’s technology network (<strong>Users</strong>) consistent with <a href="https://president.asu.edu/asu-mission-and-goals"target="_blank" rel="noopener noreferrer">ASU’s Charter and Mission</a>.</p>

<p>In addition to information and services provided on ASU websites, ASU may also provide connections to external services and information provided by non-ASU service providers. These non-ASU provided services may include Amazon Web Services, Microsoft 365 and Windows, and the education versions of Dropbox and Google, which includes Gmail. Non-ASU service providers have their own privacy policies that are not covered by this Privacy Statement. ASU is not responsible for the privacy practices or policies of non-ASU service providers. We recommend you review the privacy practices and policies of all non-ASU service providers.</p>

<strong>Information ASU collects from users and how we use it</strong>

<p>ASU collects information actively provided by Users. We may also collect information about the computers, mobile devices, or other devices you use to access ASU’s websites and technology network, such as IP address, unique device identifiers, browser types, browser languages, web pages visited, network software access, referring web pages, date, time, and duration of activity, passwords, and accounts accessed, volume of data storage and transfers, and locations of User devices when connected to ASU’s websites and technology network. Logs of this information may be retained. We may contract with non-ASU service providers to help us better understand Users.</p>

<p>ASU uses information collected to provide services, in support of ASU’s Charter and Mission, to protect the security of ASU’s technology network, to support academic integrity, and to provide safety and security services to Users, as well as to monitor, preserve, and enhance the use, functioning, and integrity of ASU’s technology network. ASU may also use information collected from you for analysis and statistical purposes consistent with ASU’s Charter and Mission.</p>

<strong>Cookies</strong>

<p>Cookies are small files that are stored on your computing devices. We use cookies to understand and save your preferences for future visits and compile aggregate data about network traffic and network interaction so that we can offer better network experiences and tools in the future. Cookies may be set by organizations other than ASU. Because the cookie policies of these third party service providers may change over time, you should review their policies by visiting their privacy policies directly. We also use targeting and advertising cookies, which may be set by ASU or by third parties. Users may disable cookies through their individual browser options. However, if you do not accept cookies, you may not be able to use some portions of our websites or technology network.</p>

<p>The following describes the types of cookies ASU uses on our websites:</p>

<p><strong>Required or strictly necessary cookies.</strong> These cookies are essential for our websites to operate correctly and to provide you with requested services. For example, we use cookies to authenticate you, so when you log on to ASU websites, we know who you are.</p>

<p><strong>Functionality cookies.</strong> We use functionality cookies to enhance website features, such as videos and live chat, and for personalization, such as storing your preferences (e.g. username and language selection). Functionality cookies may be set by ASU or by third parties whose services we have added to our websites. If you do not allow these cookies, you may not be able to use some portions of our websites or technology network, and some website may not work properly.</p>

<p><strong>Social media cookies.</strong> Social media cookies may be set by third parties such as YouTube and Facebook to collect information about your social media usage.</p>

<p><strong>Analytics cookies.</strong> Analytics cookies collect information about your use of our websites and technology network, and help us improve the way it works. For example, analytics cookies identify the most frequently visited pages, record any difficulties you have, and show whether our advertising is effective. This allows us to see the overall patterns of usage, rather than the usage of a single person. We use the information to analyze the websites' traffic.</p>

<p><strong>Targeting/advertising cookies.</strong> We use targeting/advertising cookies to create profiles and personalize content. We may use third party products, such as Google Analytics, to market ASU’s services to you on third party websites. For example, if you visit ASU websites, you may then see advertisements for ASU on other websites.</p>

<p>You can learn more about cookies and their functions generally by visiting an information website such as <a href="http://allaboutcookies.org/"target="_blank" rel="noopener noreferrer">allaboutcookies.org</a>.</p>

<p><strong>Do not track signals.</strong> Some web browsers have a "Do Not Track" (<strong>DNT</strong>) feature that tells websites that users do not want to have their online activity tracked.</p>

<strong>Alternatives to website transactions</strong>

<p>If you prefer not to provide information to ASU through our websites or technology network, you may contact the ASU administrative unit responsible for the service to learn about available options.</p>

<strong>Disclosure of information</strong>

<p>ASU does not disclose confidential information we collect online to individuals or entities not affiliated with ASU, except in the limited circumstances described below. Non-confidential information may be disclosed or distributed pursuant to federal laws, state laws, including Arizona’s public records laws, and ASU and Arizona Board of Regents (<strong>ABOR</strong>) policies. These laws and policies explain what information may be shared or disclosed. They also explain what information is protected as confidential.</p>

<p><strong>Student Records.</strong> Certain records of students are protected by the federal <a href="https://students.asu.edu/policies/ferpa"target="_blank" rel="noopener noreferrer">Family Educational Rights and Privacy Act (<strong>FERPA</strong>)</a>, Arizona law, and ASU Policy. Information about students’ access to their education records and protection of education records is available in ASU’s <a href="https://www.asu.edu/aad/manuals/ssm/ssm107-01.html"target="_blank" rel="noopener noreferrer">Student Services Manual in Section 107-01</a>. This policy also provides information on students’ rights to limit access to their directory information. ASU may disclose confidential student information with the consent of the student, under subpoena or court order, or in other limited circumstances as permitted by FERPA and other applicable laws.</p>

<p><strong>Employee records.</strong> Access to ASU personnel records is governed by <a href="http://www.azregents.edu/privacy-policy"target="_blank" rel="noopener noreferrer">ABOR Policy 6-912</a>, <a href="https://www.asu.edu/aad/manuals/acd/acd811.html"target="_blank" rel="noopener noreferrer">ACD 811</a>, <a href="https://www.asu.edu/aad/manuals/policyarchives/SPP/Mar2008/spp1101.html"target="_blank" rel="noopener noreferrer">SPP 1101</a>, and Arizona law.</p>

<p><strong>Public records laws.</strong> ASU may be required to provide access to ASU records to third parties pursuant to Arizona’s public records laws <a href="http://www.azleg.gov/arsDetail/?title=39"target="_blank" rel="noopener noreferrer">ARS §§ 39-121 through 39-161</a>. Additional information about Arizona’s public records laws is available at <a href="https://ogc.asu.edu/public-records/"target="_blank" rel="noopener noreferrer">ogc.asu.edu/public-records/</a>.</p>

<p><strong>Court order or public safety.</strong> ASU may be required to disclose confidential information pursuant to a valid court order or lawfully issued and served subpoena, search warrant, or other legal order. In addition, ASU may disclose confidential information to law enforcement if ASU believes that disclosure is necessary to protect ASU, to protect the health or safety of individuals, or if law enforcement believes that ASU’s resources have been used in the commission of a crime.</p>

<p><strong>Contractors.</strong> ASU may contract with non-ASU service providers to provide services and information through ASU’s websites and technology network. ASU may provide information, including personal information collected on our technology network; to non-ASU service providers to assist ASU deliver classes, programs, products, information, and services. ASU also contracts with non-ASU service providers to perform analysis, research, and administrative activities for ASU. ASU requires non-ASU service providers to protect personal information on our behalf.</p>

<strong>Security</strong>

<p>ASU takes steps to ensure that confidential information collected online is secure. These steps include: ongoing User education; using tools in an effort to restrict unauthorized access, viruses, phishing, and hacking attempts; and monitoring activity to identify potential system threats. ASU routinely assesses and enhances tools and processes available to strengthen our online security.</p>

<strong>Contact information</strong>

<p>If you believe ASU has not adhered to this Privacy Statement, please contact ASU’s privacy team at <a href="mailto:privacy@asu.edu"target="_blank" rel="noopener noreferrer">privacy@asu.edu</a>. ASU will use reasonable efforts to address your concerns; although there may be circumstances where we cannot assist.</p>

<strong>Changes</strong>

<p>We will publish on our website any changes we make to this Privacy Statement.</p>

<p>Effective: 8.9.2001<br />
Revised: 11.5.2019</p>

                    </Typography>
                  </Container>
                </DialogContent>
              </Dialog>
        </DialogContent>
    )
}

export default SignUp;